/**
 * Renders a <Select> dropdown when `options` is non-empty, otherwise a free-text
 * <Input>. Used for Class / Section / Room pickers in AllocationSection.
 */
import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function MasterSelectOrInput({
  options,
  value,
  onChange,
  testId,
  placeholder,
  optionLabel = (v) => v,
}) {
  if (options.length > 0) {
    return (
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger data-testid={testId} className="bg-white">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt} value={opt}>{optionLabel(opt)}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }
  return (
    <Input
      data-testid={testId}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white"
      placeholder={placeholder}
    />
  );
}
